import http from './http-service'
import config from '../config/constant'
import env from 'custom/config/environment'

const verifyInternalBeneficiary = async (data) => {
  try {
    const reqParams = {
      addrline: '',
      bankCode: '',
      bankName: '',
      beneAccNo: data?.accountNumber,
      beneBrn: '',
      beneName: '',
      beneType: 'INBK',
      bicCode: '',
      city: '',
      favorites: 'N',
      isVisibleToGroup:
        data?.isVisibleToGroup === false || data?.isVisibleToGroup === undefined ? 'N' : 'Y',
      maxTransferLimit: data?.maxTransferAmount?.replaceAll(',', ''),
      operationType: 'A',
      shortName: data?.nickName,
      sortCode: '',
      terms: 'Y',
      requestId: 'REGISTUSER',
      beneCurrency: env.LOCAL_CURRENCY_CODE,
    }
    const response = await http.post(
      config.beneficiary.corpInternalBankBeneficiaryVerify,
      reqParams,
    )
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const confirmInternalBeneficiary = async (data) => {
  try {
    const reqParams = {
      isVisibleToGroup:
        data?.isVisibleToGroup === false || data?.isVisibleToGroup === undefined ? 'N' : 'Y',
      beneAccNo: data.beneAccNo || data.accountNumber,
      beneBrn: data.beneBrn,
      beneCurrency: data.beneCurrency,
      beneName: data.beneName,
      beneType: 'INBK',
      favorites: 'N',
      randomKey: data.randomKey,
      maxTransferLimit: data.maxTransferAmount?.replaceAll(',', ''),
      shortName: data.nickName,
      operationType: 'A',
      otp: data.otp || '0000',
      requestId: 'REGISTUSER',
    }
    const response = await http.post(
      config.beneficiary.corpInternalBankBeneficiaryConfirm,
      reqParams,
    )
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const verifyInternationalBeneficiary = async (reqParams) => {
  try {
    const data = {
      addrline: reqParams.beneAddress,
      bankAddress: reqParams.bankAddress,
      bankCode: reqParams.code,
      bankCountry: reqParams.bankCountry,
      bankName: reqParams.bankName,
      beneAccNo: reqParams.accountNumber,
      beneCountry: reqParams.beneCountry,
      beneBrn: reqParams.bankBranch,
      beneEmail: reqParams.beneEmail,
      beneMobileNo: reqParams.beneMobileNo,
      beneCurrency: '',
      beneName: reqParams.benName,
      beneType: 'INTERNATIONAL',
      bicCode: reqParams.code,
      city: reqParams.bankCountry || '',
      favorites: 'N',
      isVisibleToGroup:
        reqParams?.isVisibleToGroup === false || reqParams?.isVisibleToGroup === undefined
          ? 'N'
          : 'Y',
      maxTransferLimit: reqParams.maxTransferAmount?.replaceAll(',', ''),
      operationType: 'A',
      shortName: reqParams.nickName,
      sortCode: reqParams.code,
      terms: 'Y',
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.beneficiary.corpOtherBankBeneficiaryVerify, data)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const confirmInternationalBeneficiary = async (reqParams) => {
  try {
    const data = {
      addrline: reqParams.beneAddress,
      bankAddress: reqParams.bankAddress,
      bankCode: reqParams.code,
      bankCountry: reqParams.bankCountry,
      bankName: reqParams.bankName,
      beneAccNo: reqParams.accountNumber,
      beneCountry: reqParams.beneCountry,
      beneBrn: reqParams.bankBranch,
      beneEmail: reqParams.beneEmail,
      beneMobileNo: reqParams.beneMobileNo,
      beneCurrency: '',
      beneName: reqParams.benName,
      beneType: 'INTERNATIONAL',
      bicCode: reqParams.code,
      city: reqParams.bankCountry || '',
      favorites: 'N',
      isVisibleToGroup:
        reqParams?.isVisibleToGroup === false || reqParams?.isVisibleToGroup === undefined
          ? 'N'
          : 'Y',
      maxTransferLimit: reqParams.maxTransferAmount?.replaceAll(',', ''),
      operationType: 'A',
      shortName: reqParams.nickName,
      sortCode: reqParams.code,
      terms: 'Y',
      otp: reqParams.otp || '0000',
      randomKey: reqParams.randomKey,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.beneficiary.corpOtherBankBeneficiaryConfirm, data)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const verifyDomesticBeneficiary = async (reqParams) => {
  try {
    const data = {
      addrline: reqParams.address || '',
      bankAddress: reqParams.address || '',
      bankCode: reqParams.bankCode,
      bankCountry: '',
      bankName: reqParams.bankName,
      beneAccNo: reqParams.accountNumber,
      beneCountry: '',
      beneBrn: '',
      beneEmail: reqParams.beneEmail,
      beneMobileNo: reqParams.beneMobileNo,
      beneCurrency: '',
      beneName: reqParams.benName,
      beneType: 'THIRD_PARTY',
      bicCode: reqParams.bicCode,
      city: reqParams.country || '',
      favorites: 'N',
      isVisibleToGroup:
        reqParams?.isVisibleToGroup === false || reqParams?.isVisibleToGroup === undefined
          ? 'N'
          : 'Y',
      maxTransferLimit: reqParams.maxTransferAmount?.replaceAll(',', ''),
      operationType: 'A',
      shortName: reqParams.nickName,
      sortCode: reqParams.sortCode || '',
      terms: 'Y',
      bankName: reqParams?.bankName || '',
      bankCode: reqParams?.bankCode || '',
      bicCode: reqParams?.bicCode || '',
      modeOfTransfer: '',
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.beneficiary.corpOtherBankBeneficiaryVerify, data)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const confirmDomesticBeneficiary = async (reqParams) => {
  try {
    const data = {
      addrline: reqParams.address || '',
      bankAddress: reqParams.address || '',
      bankCode: reqParams.bankCode,
      bankCountry: '',
      bankName: reqParams.bankName,
      beneAccNo: reqParams.accountNumber,
      beneCountry: '',
      beneBrn: reqParams.branchName,
      beneEmail: reqParams.beneEmail,
      beneMobileNo: reqParams.beneMobileNo,
      beneCurrency: '',
      beneName: reqParams.benName,
      beneType: 'THIRD_PARTY',
      bicCode: reqParams.bicCode,
      city: reqParams.country || '',
      favorites: 'N',
      isVisibleToGroup:
        reqParams?.isVisibleToGroup === false || reqParams?.isVisibleToGroup === undefined
          ? 'N'
          : 'Y',
      maxTransferLimit: reqParams.maxTransferAmount?.replaceAll(',', ''),
      operationType: 'A',
      shortName: reqParams.nickName,
      sortCode: reqParams.sortCode,
      terms: 'Y',
      otp: reqParams.otp || '0000',
      randomKey: reqParams.randomKey,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.beneficiary.corpOtherBankBeneficiaryConfirm, data)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const verifyRegionalBeneficiary = async (reqParams) => {
  try {
    const data = {
      addrline: reqParams.address || '',
      bankAddress: reqParams.address || '',
      bankCode: reqParams.bankCode,
      bankCountry: '',
      bankName: reqParams.bankName,
      beneAccNo: reqParams.accountNumber,
      beneCountry: '',
      beneBrn: reqParams.branchName,
      beneEmail: reqParams.beneEmail,
      beneMobileNo: reqParams.beneMobileNo,
      beneCurrency: '',
      beneName: reqParams.benName,
      beneType: 'REGION',
      bicCode: reqParams.bicCode,
      city: reqParams.country || '',
      favorites: 'N',
      isVisibleToGroup:
        reqParams?.isVisibleToGroup === false || reqParams?.isVisibleToGroup === undefined
          ? 'N'
          : 'Y',
      maxTransferLimit: reqParams.maxTransferAmount?.replaceAll(',', ''),
      operationType: 'A',
      shortName: reqParams.nickName,
      sortCode: reqParams.sortCode,
      terms: 'Y',
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.beneficiary.corpOtherBankBeneficiaryVerify, data)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const confirmRegionalBeneficiary = async (reqParams) => {
  try {
    const data = {
      addrline: reqParams.address || '',
      bankAddress: reqParams.address || '',
      bankCode: reqParams.bankCode,
      bankCountry: '',
      bankName: reqParams.bankName,
      beneAccNo: reqParams.accountNumber,
      beneCountry: '',
      beneBrn: reqParams.branchName,
      beneEmail: reqParams.beneEmail,
      beneMobileNo: reqParams.beneMobileNo,
      beneCurrency: '',
      beneName: reqParams.benName,
      beneType: 'REGION',
      bicCode: reqParams.bicCode,
      city: reqParams.country || '',
      favorites: 'N',
      isVisibleToGroup:
        reqParams?.isVisibleToGroup === false || reqParams?.isVisibleToGroup === undefined
          ? 'N'
          : 'Y',
      maxTransferLimit: reqParams.maxTransferAmount?.replaceAll(',', ''),
      operationType: 'A',
      shortName: reqParams.nickName,
      sortCode: reqParams.sortCode,
      terms: 'Y',
      otp: reqParams.otp || '0000',
      randomKey: reqParams.randomKey,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.beneficiary.corpOtherBankBeneficiaryConfirm, data)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getAllBankDetails = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.getAllBanks, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getSwiftCountry = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.beneficiary.getSwiftCountry, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getBeneList = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.beneficiary.getAllBeneficiariesList, reqParams)
    const beneficiaries = response.data

    const beneficiaryList = [...beneficiaries.internalBeneList, ...beneficiaries.otherBankBeneList]

    const accountList = beneficiaryList.map((v) => v.beneAccNo)

    const req = {
      accNo: [...accountList],
      requestId: 'REGISTUSER',
    }
    const imagesResponse = await http.post(config.beneficiary.getBeneficiaryImages, req)
    const images = imagesResponse.data.imagesList
    beneficiaries.internalBeneList.forEach((ben) => {
      const image = images.find((v) => ben.beneAccNo === v.accNo)
      ben.image = image === undefined ? null : `data:image/png;base64,${image.imageData}`
    })
    beneficiaries.otherBankBeneList.forEach((ben) => {
      const image = images.find((v) => ben.beneAccNo === v.accNo)
      ben.image = image === undefined ? null : `data:image/png;base64,${image.imageData}`
    })
    return { status: response.status, data: beneficiaries }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getBeneImages = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.beneficiary.getBeneficiaryImages, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const modifyInternalInitBeneVerify = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.beneficiary.modifyInternalInitBeneVerify, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const modifyInternalInitBeneConfirm = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.beneficiary.modifyInternalInitBeneConfirm, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const removeInitBeneVerify = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.beneficiary.removeInitBeneVerify, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const removeInitBeneConfirm = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.beneficiary.removeInitBeneConfirm, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const updateBeneImage = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.beneficiary.uploadImage, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const removeBeneficiaryImage = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.beneficiary.removeBeneficiaryImage, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const modifyDomesticBeneVerifyVerify = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(
      config.beneficiary.modifyInitThirdPartyBenificiaryVerify,
      reqParams,
    )
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const modifyDomesticBeneVerifyConfirm = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(
      config.beneficiary.modifyInitThirdPartyBenificiaryConfirm,
      reqParams,
    )
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

export const viewScheduledPayments = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'INTERNALACCTRANSFER',
      page: 0,
      size: 10,
      module: 'SCHEDULED_TRANSFER',
    }
    const response = await http.post(config.beneficiary.viewSchedulePayment, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    console.log(err)
    throw err.response.data
  }
}
export const verifyCancelScheduledPayments = async (data) => {
  try {
    const reqParams = {
      id: data.id,
      requestId: 'INTERNALACCTRANSFER',
      module: 'SCHEDULEDPAYMENTS',
    }
    const response = await http.post(config.beneficiary.verifyCancelScheduledPayments, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    console.log(err)
    throw err.response.data
  }
}
export const confirmCancelScheduledPayments = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'INTERNALACCTRANSFER',
      module: 'SCHEDULEDPAYMENTS',
    }
    const response = await http.post(config.beneficiary.confirmCancelScheduledPayments, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    console.log(err)
    throw err.response.data
  }
}

const BeneficiaryService = {
  verifyInternalBeneficiary,
  confirmInternalBeneficiary,
  getAllBankDetails,
  getSwiftCountry,
  verifyInternationalBeneficiary,
  confirmInternationalBeneficiary,
  verifyDomesticBeneficiary,
  getBeneList,
  getBeneImages,
  confirmDomesticBeneficiary,
  modifyInternalInitBeneVerify,
  modifyInternalInitBeneConfirm,
  removeInitBeneVerify,
  removeInitBeneConfirm,
  updateBeneImage,
  removeBeneficiaryImage,
  modifyDomesticBeneVerifyVerify,
  modifyDomesticBeneVerifyConfirm,
  viewScheduledPayments,
  verifyCancelScheduledPayments,
  confirmCancelScheduledPayments,
  verifyRegionalBeneficiary,
  confirmRegionalBeneficiary,
}

export default BeneficiaryService
